/* istanbul ignore file */
import React from 'react';
import { isFunction } from 'underscore';
import { Toggle, MessageBar, MessageBarType } from '@fluentui/react';

declare const _TL_;
interface IProps {
  checked: boolean;
  i18n: any;
  activityLogger: any;
  parent: any;
  labelTxt: string;
  onTxt: string;
  offTxt: string;
  isAudienceFeedBasedCampaign: boolean;
  alwaysDisabled: boolean;
}

const getAudienceFeedBasedCampaignPredictiveTargetingText = i18n => (
  <div>
    <strong className="feed-based-campaign-predictive-targeting-text">
      {i18n.getString(_TL_('Predictive targeting is automatically enabled for feed-based campaigns. Please note that this won’t impact campaign performance, as the audience signals associated with predictive targeting have already been serving with all feed-based campaigns. '))}
    </strong>
    <a href="https://help.ads.microsoft.com/#apex/ads/en/60148/1">
      {i18n.getString(_TL_('Learn more about predictive targeting.'))}
    </a>
  </div>
);

export class OptTgtToggle extends React.Component<IProps,
  { checked: boolean, disable: boolean, shouldShowTargetExclusionActualDeliveryStatus: boolean}> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      checked: props.checked,
      disable: !this.validate(),
      shouldShowTargetExclusionActualDeliveryStatus: false,
    };
  }

  onChange = (ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
    const { parent } = this.props;
    const { i18n } = this.props;
    if (this.props.activityLogger && this.props.activityLogger.signal) {
      this.props.activityLogger.signal(`Status change, checked: ${checked}`, 'predictive targeting toogle button');
    }
    if (checked === false) {
      if (!this.validate()) {
        parent.errorsView.setErrors([{
          message: i18n.getString(_TL_('Predictive targeting cannot be turned off if ad group does not have any target.')),
        }]);
        return; // Opt Tgt cannot be turned off if there is no effective targets.
      }
    }

    this.setState({
      checked,
    }, () => {
      parent.handleEstimateUpdates(parent);
      if (isFunction(parent.handleAgeGenderExclusion)) {
        // in setting page and enable flag
        // true means we are delivery actual delivery status wiht PT setting and target type
        this.setState({
          shouldShowTargetExclusionActualDeliveryStatus: parent.handleAgeGenderExclusion(),
        });
      }
    });
  }

  getData = () => this.state.checked

  validate = () => {
    const { alwaysDisabled } = this.props;
    const effectiveTgts = this.props.parent.currentLevelTargetInfo &&
      this.props.parent.currentLevelTargetInfo.getEffectiveCriterions();
    return effectiveTgts && effectiveTgts.length > 0 && !alwaysDisabled;
  }

  disableByValidation() {
    const validate = this.validate();
    const { disable } = this.state;
    let { checked } = this.state;

    // If change from non-disable to disable,
    // set checked to initial value or default to true if it's null
    if (validate && disable === true) {
      checked = (this.props.checked == null) ? true : checked;
    }

    this.setState({
      checked,
      disable: !validate,
    });

    return checked;
  }

  render() {
    const {
      i18n, labelTxt, onTxt, offTxt, isAudienceFeedBasedCampaign,
    } = this.props;
    const { checked, disable, shouldShowTargetExclusionActualDeliveryStatus } = this.state;
    if (isAudienceFeedBasedCampaign) {
      return getAudienceFeedBasedCampaignPredictiveTargetingText(i18n);
    }
    return (
      <>
        <Toggle
          checked={checked}
          onText={onTxt || i18n.getString(_TL_('On'))}
          offText={offTxt || i18n.getString(_TL_('Off'))}
          inlineLabel={false}
          label={labelTxt || i18n.getString(_TL_('Use predictive targeting'))}
          onChange={this.onChange}
          disabled={disable}
        />
        {disable &&
        <MessageBar
          messageBarType={MessageBarType.warning}
          isMultiline={false}
          dismissButtonAriaLabel="Close"
        >
          {i18n.getString(_TL_('Predictive targeting is required when no audience target is selected. Select an audience target to unlock this control'))}
        </MessageBar>
        }
        {shouldShowTargetExclusionActualDeliveryStatus &&
        <MessageBar
          messageBarType={MessageBarType.warning}
          isMultiline={false}
          dismissButtonAriaLabel="Close"
        >
          {i18n.getString(_TL_('Based on your new settings, we’ve modified your age and gender exclusion settings. Please review these settings to ensure that they are accurate.'))}
        </MessageBar>
        }
      </>
    );
  }
}
